import React, { useState } from 'react'
import { Button, FallBackImage } from '../TagsUse/data'
// import { IoMdCheckmarkCircleOutline } from 'react-icons/io'
import { studioSpace } from '../../Context/dummy'
import { IoMdCheckmarkCircleOutline } from 'react-icons/io'

function Listing() {
     const [filterproducts,setProducts]=useState(studioSpace)
      const handleSearch=(value)=>{ 
                let search=studioSpace.filter((item)=>item.title.toLowerCase().includes(value.toLowerCase()))
                setProducts(search)
            }
  return (
 <div className='container our_product my-5'>
    <div className='d-flex justify-content-between align-items-start flex-wrap px-2'>
            <h5 className='m-md-0 my-2'>Our Rental Spaces</h5>
            <input onChange={(e)=>handleSearch(e.target.value)} type="text" style={{background:"#f6f6f6",border:"none",borderRadius:"3px "}} placeholder="Search by Sets"/>
            </div>
      {filterproducts?.map((item, i) => (
        <div
          className={`row m-0 ${i % 2 !== 0 ? 'flex-md-row-reverse' : ''}`}
          key={i}
        >
          {/* Image Section */}
          <div className='col-lg-6 col-md-6 col-12 my-3'>
            <FallBackImage
              src={item?.image}
              alt="Studio Image"
              className="studio-image w-100"
              fallbackSrc={item?.image}
            />
          </div>

          {/* Content Section */}
          <div className='col-lg-6 col-md-6 col-12 d-flex justify-content-center align-items-center my-3'>
            <div>
              <h6 className='studio_heding'>{item?.title}</h6>
              <p className='sub_title_studio'>Price: {item?.fixed_price}</p>

              {/* Amenities List */}
              {item?.aminties&&<ul className='p-0'>
                {item?.aminties.map((list, index) => (
                  <li
                    className='stu_amin d-flex align-items-center'
                    style={{ listStyle: 'none' }}
                    key={index}
                  >
                    <IoMdCheckmarkCircleOutline style={{ color: '#483B8B' }} />
                    <span className='mx-1'>{list}</span>
                  </li>
                ))}
              </ul>}

              {/* <p>{item?.text2}</p> */}

              {/* Pricing Table */}
              <div className='d-flex justify-content-between'>
                {!item?.fixed_price&&<table className='table table-sm'>
                  <thead>
                    <tr>
                      <th style={{ backgroundColor: '#F2F2F2' }}>Price</th>
                      <th style={{ backgroundColor: '#F2F2F2' }}>Duration</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{item?.tow_hours_price}</td>
                      <td>2 hours</td>
                    </tr>
                    <tr>
                      <td>{item?.four_hours_price}</td>
                      <td>4 hours</td>
                    </tr>
                    <tr>
                      <td>{item?.eight_hours_price}</td>
                      <td>8 hours</td>
                    </tr>
                  </tbody>
                </table>}
              </div>
              <p>{item?.text}</p>

              {/* Booking Button */}
              <a
                href={`https://wa.me/+923051115501`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button text="Book Now" className="booking_btn" />
              </a>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default Listing